import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { truncate } from 'lodash';
import styles from './TeamSelector.m.sass';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import Icon from '../../../components/Icon';
import NewTeamModal from '../NewTeamModal';
import Avatar from '../../../components/Avatar';

/**
 * Team selector used for the team management screen as well
 * as for selecting a team in other contexts.
 */
var TeamSelector = observer(_class = /*#__PURE__*/function (_React$Component) {
  function TeamSelector() {
    _classCallCheck(this, TeamSelector);
    return _callSuper(this, TeamSelector, arguments);
  }
  _inherits(TeamSelector, _React$Component);
  return _createClass(TeamSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.teamManagementStore.activate();
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
        teamManagementStore = _this$props.teamManagementStore,
        allowCreation = _this$props.allowCreation,
        onTeamClick = _this$props.onTeamClick,
        simple = _this$props.simple,
        additionalItems = _this$props.additionalItems;
      var teams = teamManagementStore.filtered,
        searchText = teamManagementStore.searchText;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.grid
      }, allowCreation && !searchText && /*#__PURE__*/React.createElement(Item, {
        title: "Create New Team",
        image: newTeamImage,
        onClick: teamManagementStore.newTeamState.show
      }), additionalItems && additionalItems.map(function (item, i) {
        return /*#__PURE__*/React.createElement(Item, {
          key: i,
          title: item.title,
          image: /*#__PURE__*/React.createElement(Avatar, {
            url: item.avatarUrl,
            size: 86,
            className: styles.image
          }),
          onClick: item.onClick
        });
      }), teams.filter(function (t) {
        var teamMember = teamManagementStore.rootStore.sessionStore.teamMembers.find(function (tm) {
          return tm.teamId === t.id;
        });
        return !t.inactive && (teamMember || teamManagementStore.rootStore.sessionStore.member.hasPermission('ADMIN_TEAMS_VIEW'));
      }).map(function (team) {
        return /*#__PURE__*/React.createElement(Item, {
          key: team.id,
          title: team.name,
          image: /*#__PURE__*/React.createElement(Avatar, {
            size: 86,
            url: team.imageUrl,
            className: styles.image
          }),
          subImageUrl: team.owner.member.avatar,
          onClick: onTeamClick.bind(null, team)
        }, !simple && /*#__PURE__*/React.createElement(React.Fragment, null, "Team Owner", ' ', /*#__PURE__*/React.createElement("span", {
          className: styles.highlight
        }, team.owner.member.displayName)));
      }), searchText && !teams.length && /*#__PURE__*/React.createElement("p", {
        className: styles.searchError
      }, "Sorry, we couldn't find any matches for", /*#__PURE__*/React.createElement("br", null), "\"", truncate(searchText, {
        length: 35
      }), "\""));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var teamManagementStore = this.props.teamManagementStore;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root)
      }, teamManagementStore.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, null);
        },
        error: function error(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return _this.renderContent();
        }
      }), /*#__PURE__*/React.createElement(NewTeamModal, {
        teamManagementStore: teamManagementStore
      }));
    }
  }]);
}(React.Component)) || _class;
export { TeamSelector as default };
function Item(_ref) {
  var title = _ref.title,
    image = _ref.image,
    subImageUrl = _ref.subImageUrl,
    children = _ref.children,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: styles.item,
    onClick: function onClick(e) {
      return e.preventDefault() || _onClick();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageContainer
  }, image, subImageUrl && /*#__PURE__*/React.createElement(Avatar, {
    size: 28,
    className: styles.subImg,
    url: subImageUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.content, !children && styles.moreSpacing)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement("p", {
    className: styles.description
  }, children)));
}
var newTeamImage = /*#__PURE__*/React.createElement("div", {
  className: styles.newTeamImage
}, /*#__PURE__*/React.createElement(Icon, {
  size: 28,
  material: true,
  name: "add"
}));
//# sourceMappingURL=index.js.map
